import React from 'react';
import UpdateExpirationCardsContainer from "./UpdateExpirationCardsContainer";

class UpdateExpirationCardsScreen extends React.Component {

    public render() {
        return <UpdateExpirationCardsContainer />
    }
}

export default UpdateExpirationCardsScreen;